import React from "react";
import Faqs from "../Components/home/Faqs";
import HomeSlider from "../Components/home/Slider";
import { Container } from "react-bootstrap";
import SectionTwo from "../Components/home/SectionTwo";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import GiftingIdeas from "../Components/home/GiftingIdeas";
import BlogTitle from "../Components/home/BlogTitle";
import DownloadCatalog from "../Components/home/DownloadCatalog";
import CustomerTestimonials from "../Components/home/CustomerTestimonials";
import DownloadReport from "../Components/home/DownloadReport";
import { Helmet } from "react-helmet-async";

const Home =()=>{
     const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Corporation",
        "@id": "https://eyantra.com/#organization",
        "name": "eYantra",
        "url": "https://eyantra.com/",
        "logo": "https://eyantra.com/assets/eyantra_logo.svg",
        "sameAs": [
          "https://www.facebook.com/eyantraindustries",
          "https://www.instagram.com/eyantra_/",
          "https://in.linkedin.com/company/eyantramerchandise",
          "https://www.youtube.com/@eYantraIndustries",
          "https://x.com/eYantra_"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-8977921314",
          "contactType": "customer service",
          "email": "info@eyantra.com",
          "areaServed": "IN"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress":
            "eYantra, 301, 3rd Floor, CSR Estate, Plot No.8, Sector-1, HUDA Techno Enclave, Madhapur Main Road, Hyderabad",
          "addressLocality": "Hyderabad",
          "postalCode": "500081",
          "addressRegion": "Telangana",
          "addressCountry": "IN"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://eyantra.com/#website",
        "url": "https://eyantra.com/",
        "name": "eYantra",
        "publisher": {
          "@id": "https://eyantra.com/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://eyantra.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://eyantra.com/#homepage",
        "url": "https://eyantra.com/",
        "name": "eYantra — Corporate gifting & onboarding kits",
        "isPartOf": {
          "@id": "https://eyantra.com/#website"
        }
      }
    ]
  };
    return(
        <>
        {/**Schema */}
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>

        <div className="container-fluid p-0 bgeYantra">
        <HomeSlider/>
        <Container className="mt-5 mb-5 bgeYantra">
            <SectionTwo />
        </Container>
        <ClinetsLogoSlider/>
        <GiftingIdeas/>
        <BlogTitle/>
        <DownloadCatalog/>
        {/* <h2>Social Media Post Section</h2> */}
        {/* <Instapost/> */}
        <CustomerTestimonials/>
        <DownloadReport/>
        </div>
        
        </>
    )
}

export default Home;